import { render, staticRenderFns } from "./YanYana.vue?vue&type=template&id=3773c1f5&scoped=true"
import script from "./YanYana.vue?vue&type=script&lang=js"
export * from "./YanYana.vue?vue&type=script&lang=js"
import style0 from "./YanYana.vue?vue&type=style&index=0&id=3773c1f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773c1f5",
  null
  
)

export default component.exports